<template>
  <div class="site-background" aria-hidden="true"></div>
  <nav>
    <div class="nav-container">
      <router-link class="p-font" to="/">Home</router-link> |
      <router-link class="p-font" to="/episodes">Episodes</router-link>
    </div>
  </nav>
  <router-view />
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:wght@400;700&family=Ruwudu:wght@600&display=swap");

#app {
  position: relative;
  isolation: isolate;
  min-height: 100vh;
  font-family: "Atkinson Hyperlegible", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.site-background {
  --backdrop-image: url("./assets/winter-pass-backdrop-v1.webp");

  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: -1;
  height: 100vh;
  height: 100lvh;
  background:
    linear-gradient(rgba(16, 21, 28, 0.58), rgba(16, 21, 28, 0.78)),
    var(--backdrop-image) center / cover no-repeat;
}
@media (max-width: 768px) {
  .site-background {
    --backdrop-image: url("./assets/winter-pass-backdrop-mobile-v2.webp");
  }
}

nav {
  display: flex;
  justify-content: center;
  .nav-container {
    padding: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    min-width: 360px;
    color: rgba(197, 221, 242, 0.72);
    font-size: 1.2rem;
    a {
      font-weight: bold;
      color: #c5ddf2;

      &:hover,
      &:focus-visible {
        color: #f3f7fb;
      }

      &.router-link-exact-active {
        color: #ffffff;
      }
    }
  }
}
body {
  background-color: #17171f;
}
hr {
  border-block-color: #6d9bc8;
  width: 80vw;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  color: #dde;
}
.logo-img {
  max-width: 20vw;

  &.logo-lg {
    min-width: 300px;
    border-radius: 20%;
  }

  &.logo-sm {
    min-width: 30px;
    border-radius: 15%;
  }
}
.dark-text {
  color: #fff;
}
.p-font {
  font-family: "Atkinson Hyperlegible", sans-serif;
  &.i {
    font-style: italic;
  }
}
.p-size {
  font-size: 1.2rem;
}
.h-font {
  font-family: "Ruwudu", serif;
}
.h-lg {
  font-size: 2.5em;
}
</style>
